<div class="row ml-1 mr-3 kanye-row">
    <div class="col-4 col-md-3 kanye-image">

    </div>
    <div class="col-8 col-md-7 kanye-quote">
        {{kanyeQuote}}
        <p class="kanye-rest-credit pt-3">(Powered by the Kanye REST API)</p>
    </div>
</div>